// API Configuration for different environments
// Automatically detect local development vs production
const getApiBase = () => {
  // If VITE_API_BASE_URL is explicitly set, use it
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }
  
  // For local development (when running on localhost)
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return 'http://localhost:5008/api';
  }
  
  // Default to production API
  return 'https://africaenergytrends.org/api';
};

const API_BASE = getApiBase();

// Site Base URL Configuration for different environments
const SITE_BASE_URL = import.meta.env.VITE_SITE_BASE_URL || 'https://africaenergytrends.org'

export { API_BASE, SITE_BASE_URL };